import type { Mode } from './types';

export const paymentsKeys = {
  all: ['payments'] as const,
  connectStatus: ['payments', 'connect', 'status'] as const,
  payouts: (mode: Mode) => ['payments', 'payouts', mode] as const,
  balance: (mode: Mode) => ['payments', 'balance', mode] as const,
};
